import { Component, inject } from '@angular/core';
import { AppLoadingService, TranslationService } from '@app/services';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-loading',
  imports: [TranslatePipe],
  templateUrl: './loading.html',
  styleUrl: './loading.css',
})
export class Loading {
  loader = inject(AppLoadingService);
  translationService = inject(TranslationService);
}
